import { useApiTradeV1SiteMaterialsRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { ActionRow, Grid } from 'ui';

import { SiteMaterialCompanyLink } from '../../../site-material';

export const SiteMaterialQualityReportFooter = ({ siteMaterialId }: { siteMaterialId: string }) => {
  const { t } = useTranslation('features');
  const { data: siteMaterial } = useApiTradeV1SiteMaterialsRetrieve(siteMaterialId);

  return (
    <Grid
      size={12}
      sx={{
        bgcolor: 'white',
        padding: 2,
      }}
    >
      <ActionRow>
        <SiteMaterialCompanyLink
          tradeCompanyId={Number(siteMaterial?.site.trade_company.id)}
          siteMaterialId={siteMaterialId}
        >
          {t('qualityReport.footer.backToSiteQualityPage')}
        </SiteMaterialCompanyLink>
      </ActionRow>
    </Grid>
  );
};
